import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const SuppressedAlertImage = props => (
    <SvgIcon {...props} viewBox="0 0 129 130" width="129" height="130">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M69.5 121.625C98.2878 121.625 121.625 98.2878 121.625 69.5C121.625 40.7122 98.2878 17.375 69.5 17.375C40.7122 17.375 17.375 40.7122 17.375 69.5C17.375 98.2878 40.7122 121.625 69.5 121.625ZM69.5 139C107.884 139 139 107.884 139 69.5C139 31.1162 107.884 0 69.5 0C31.1162 0 0 31.1162 0 69.5C0 107.884 31.1162 139 69.5 139ZM71.2373 34.75C76.0353 34.75 79.9248 38.6395 79.9248 43.4375V72.3958C79.9248 77.1938 76.0353 81.0833 71.2373 81.0833C66.4394 81.0833 62.5498 77.1938 62.5498 72.3958V43.4375C62.5498 38.6395 66.4394 34.75 71.2373 34.75ZM71.2373 104.25C76.0353 104.25 79.9248 100.36 79.9248 95.5625C79.9248 90.7645 76.0353 86.875 71.2373 86.875C66.4394 86.875 62.5498 90.7645 62.5498 95.5625C62.5498 100.36 66.4394 104.25 71.2373 104.25Z"
            fill="#CADCEE"
        />
    </SvgIcon>
);

export default SuppressedAlertImage;
